import {VideoEvent} from './VideoEvent';

export class VideoCreated extends VideoEvent {}
